/**
 * 센서 타입 정의
 * 온도, 습도, 토양수분, 조도 센서의 측정값 범위, 단위, 이상치 기준 포함
 */
// ---------------------------------------------------------------------------
// Enums (const object pattern — ESM 친화적)
// ---------------------------------------------------------------------------
export const SensorType = {
    // 기상 / 환경 — 값은 ESP32가 발행하는 sensorType 파라미터(약어)
    TEMPERATURE: 'temp',
    HUMIDITY: 'hum',
    ILLUMINANCE: 'illum',
    CO2: 'co2',
    ATMOSPHERIC_PRESSURE: 'pres',
    UV_INDEX: 'uv',
    WIND_SPEED: 'wind_s',
    WIND_DIRECTION: 'wind_d',
    RAINFALL: 'rain',
    // 토양
    SOIL_MOISTURE: 'soil_m',
    SOIL_TEMPERATURE: 'soil_t',
    // 양액 / 수질
    EC: 'ec',
    PH: 'ph',
    // 작물
    LEAF_WETNESS: 'leaf_w',
};
export const AnomalyLevel = {
    NORMAL: 'normal',
    WARNING: 'warning',
    CRITICAL: 'critical',
};
/**
 * 센서 타입별 메타데이터 — 단일 진실 소스
 * 범위 검증 · 이상치 탐지에 사용한다.
 */
export const SENSOR_CONFIGS = {
    // ── 기상 / 환경 ─────────────────────────────────────────────────────────
    [SensorType.TEMPERATURE]: {
        unit: '°C',
        validMin: -40,
        validMax: 85,
        threshold: { warnLow: 0, warnHigh: 35, criticalLow: -5, criticalHigh: 40 },
        description: '대기 온도',
    },
    [SensorType.HUMIDITY]: {
        unit: '%RH',
        validMin: 0,
        validMax: 100,
        threshold: { warnLow: 20, warnHigh: 80, criticalLow: 10, criticalHigh: 95 },
        description: '대기 상대습도',
    },
    [SensorType.ILLUMINANCE]: {
        unit: 'lux',
        validMin: 0,
        validMax: 100_000,
        threshold: { warnHigh: 80_000, criticalHigh: 100_000 },
        description: '조도 (가시광선 조명량)',
    },
    [SensorType.CO2]: {
        unit: 'ppm',
        validMin: 0,
        validMax: 5_000,
        threshold: { warnHigh: 1_000, criticalHigh: 2_000 },
        description: '이산화탄소 농도',
    },
    [SensorType.ATMOSPHERIC_PRESSURE]: {
        unit: 'hPa',
        validMin: 800,
        validMax: 1_100,
        threshold: { warnLow: 950, criticalLow: 920 },
        description: '대기압',
    },
    [SensorType.UV_INDEX]: {
        unit: 'UV',
        validMin: 0,
        validMax: 11,
        threshold: { warnHigh: 6, criticalHigh: 8 },
        description: '자외선 지수',
    },
    [SensorType.WIND_SPEED]: {
        unit: 'm/s',
        validMin: 0,
        validMax: 60,
        threshold: { warnHigh: 10, criticalHigh: 20 },
        description: '풍속',
    },
    [SensorType.WIND_DIRECTION]: {
        unit: '°',
        validMin: 0,
        validMax: 360,
        threshold: {},
        description: '풍향 (0~360°)',
    },
    [SensorType.RAINFALL]: {
        unit: 'mm',
        validMin: 0,
        validMax: 500,
        threshold: { warnHigh: 50, criticalHigh: 100 },
        description: '강우량',
    },
    // ── 토양 ────────────────────────────────────────────────────────────────
    [SensorType.SOIL_MOISTURE]: {
        unit: '%',
        validMin: 0,
        validMax: 100,
        threshold: { warnLow: 20, warnHigh: 90, criticalLow: 10, criticalHigh: 95 },
        description: '토양 수분 함량',
    },
    [SensorType.SOIL_TEMPERATURE]: {
        unit: '°C',
        validMin: -10,
        validMax: 60,
        threshold: { warnLow: 5, warnHigh: 35, criticalLow: 0, criticalHigh: 40 },
        description: '지온 (토양 온도)',
    },
    // ── 양액 / 수질 ─────────────────────────────────────────────────────────
    [SensorType.EC]: {
        unit: 'mS/cm',
        validMin: 0,
        validMax: 10,
        threshold: { warnLow: 0.5, warnHigh: 3.0, criticalLow: 0.2, criticalHigh: 5.0 },
        description: '전기전도도 (양액 농도)',
    },
    [SensorType.PH]: {
        unit: 'pH',
        validMin: 0,
        validMax: 14,
        threshold: { warnLow: 5.5, warnHigh: 7.0, criticalLow: 4.5, criticalHigh: 8.0 },
        description: '수소이온농도 (산도)',
    },
    // ── 작물 ────────────────────────────────────────────────────────────────
    [SensorType.LEAF_WETNESS]: {
        unit: '%',
        validMin: 0,
        validMax: 100,
        threshold: { warnHigh: 80, criticalHigh: 95 },
        description: '엽면 수분',
    },
};
//# sourceMappingURL=sensor.js.map